import DoglinkElement from "./DoglinkElement";
import icons from "../helpers/icons";
import React from "react";


const SisteHunder = ({hunder}) => {

    const rows = hunder.map(f =>
        <DoglinkElement
            key={f.id}
            linkTo={`/hund?id=${f.hundId}`}
            iconFirst={icons.bookmark}
            iconLast={icons.arb}
            data={f}
        />
    );

    return (
        <>
            { hunder && hunder.length > 0 &&
                <li>
                    <strong>DE SENESTE VISTE HUNDE</strong>
                    <ul>
                        {rows}
                    </ul>
                </li>
            }

        </>
    );

};
export default SisteHunder;